import { login } from '../../api/auth';
import authHelper from '../../helpers/auth';
import alertHelper from '../../helpers/alert';
import { PROGRESS_START, PROGRESS_FINISH, PROGRESS_FAIL } from '../mutation-types';

const defaultState = () => ({
	isAuth: authHelper.loggedIn(),
	userData: authHelper.getUserData(),
	isAttempting: false,
	alerts: [],
	fieldErrors: {},
});

const state = defaultState();

const getters = {
	isAuth() {
		return state.isAuth;
	},
};

const mutations = {
	attempting(state) {
		state.isAttempting = true;
		state.alerts = [];
		state.fieldErrors = {};
	},
	attempted(state) {
		state.isAttempting = false;
	},
	failed(state, { code, type, message }) {
		state.alerts = alertHelper.make(state.alerts, code, type, message);
	},
	validationError(state, errors) {
		state.fieldErrors = Object.assign({}, state.fieldErrors, errors);
	},
	success(state, authData) {
		state.isAuth = true;
		authHelper.setData(authData);
		state.alerts = [];
		state.fieldErrors = {};
	},
	setUserData(state){
		state.userData =  authHelper.getUserData()
	},
	removeAlert(state, id) {
		const index = Array.from(state.alerts).findIndex(it => it.id === id);

		if (index !== -1) {
			state.alerts.splice(index, 1);
		}
	},
	clearData() {
		state.isAuth = false;
		authHelper.clearData();
	},
	reset(state) {
		Object.assign(state, defaultState());
	},
};

const actions = {
	login({ commit, dispatch }, { username, password }) {
		return new Promise((resolve) => {
			commit(PROGRESS_START, null, { root: true });
			commit('attempting');

			login(username, password).then((res) => {
				commit('success', res.data.data);
				commit(PROGRESS_FINISH, null, { root: true });
				resolve(true);
			}).catch((err) => {
				const { data } = err.response;
				commit(PROGRESS_FAIL, null, { root: true });
				dispatch('errorHandler', data);
			}).then(() => {
				commit('attempted');
			});
		});
	},
	logout({ commit }) {
		commit('clearData');

		return Promise.resolve(true);
	},
	errorHandler({ commit }, response ) {
		switch (response.message) {
			case 'error_validation':
			commit('validationError', response.data);
			break;

			default:
			commit('failed', { code: 'error_response', type: 'error', message: response.message });
			break;
		}
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};
